enum HelmetHttpStatusCode {
    Okay = 200,
    NotFound = 404,
    Error = 500
}

export default HelmetHttpStatusCode; 
